import React from 'react';

import detailIcon from '../../public/images/icons/detail-icon.svg';
import professionalIcon from '../../public/images/icons/professional-icon.svg';
import honestIcon from '../../public/images/icons/always-honest-icon.svg';
import featuresIcon from '../../public/images/icons/digital-features-icon.svg';

import styles from './WhyWereSpecial.module.scss';

const {
  'why-were-special': whyWereSpecialClass,
  points: pointsClass,
  point: pointClass,
  image: imageClass,
  copy: copyClass
} = styles;

const points = [
  {
    image: detailIcon,
    title: 'Covers every detail',
    subtitle: 'So loved ones aren’t left to fill in the blanks or guess what they should do.'
  },
  {
    image: professionalIcon,
    title: 'Professional services',
    subtitle:
      'Our packages always include the quality services and guidance loved ones will need to navigate through a very difficult time.'
  },
  {
    image: honestIcon,
    title: 'Always honest',
    subtitle: 'Transparent prices, never any hidden fees for you or your family.'
  },
  {
    image: featuresIcon,
    title: 'Digital features to fit your modern life',
    subtitle:
      'Give loved ones the keys to your all-inclusive online plan, with 24/7 access to get back any time, and provide unique tools to help your family after you pass.'
  }
];

const WhyWereSpecial = () => {
  return (
    <div className={whyWereSpecialClass}>
      <h2>Why we're special</h2>
      <p>
        We contract with the best, full-service funeral homes and mortuaries across the country to
        provide our custom packages to you - 100% online.
      </p>
      <div className={pointsClass}>
        {points.map(point => (
          <div key={`${point.title}_${point.subtitle}`} className={pointClass}>
            <div className={imageClass}>
              <img src={point.image} alt="" />
            </div>
            <div className={copyClass}>
              <h4>{point.title}</h4>
              <p>{point.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyWereSpecial;
